// ABOUTME: Reusable toggle button component for panel icons
// ABOUTME: Used in both the nav bar and within panels themselves

import React from 'react';
import styled from 'styled-components';
import { LucideIcon } from 'lucide-react';
import { colors } from '@annote/core/styles';
import { useIconSize } from 'src/context/SettingsContext';

export const NAV_ICON_VISUAL_SIZE = 18;

const ToggleButton = styled.button<{ $isActive?: boolean; $iconSize: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${({ $iconSize }) => `${$iconSize}px`};
  min-height: ${({ $iconSize }) => `${$iconSize}px`};
  width: auto;
  height: auto;
  border: none;
  background: transparent;
  color: ${({ $isActive }) => ($isActive ? colors.icon.primary : colors.icon.placeholder)};
  cursor: pointer;
  transition: color 150ms ease, opacity 150ms ease;
  padding: 0;

  &:hover {
    color: ${colors.icon.hover};
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    color: ${colors.icon.primary};
  `}

  svg {
    width: ${NAV_ICON_VISUAL_SIZE}px;
    height: ${NAV_ICON_VISUAL_SIZE}px;
  }
`;

// Icon type that accepts both Lucide icons and custom icon components
type IconComponent = LucideIcon | React.FC<{ size?: number }>;

interface PanelToggleButtonProps {
  icon: IconComponent;
  onClick: () => void;
  isActive?: boolean;
  title?: string;
  className?: string;
}

export const PanelToggleButton: React.FC<PanelToggleButtonProps> = ({
  icon: Icon,
  onClick,
  isActive = false,
  title,
  className,
}) => {
  const iconSize = useIconSize('button');

  return (
    <ToggleButton $isActive={isActive} $iconSize={iconSize} onClick={onClick} title={title} className={className}>
      <Icon size={NAV_ICON_VISUAL_SIZE} />
    </ToggleButton>
  );
};
